import { useState } from "react";
import { AppContext } from "./AppContext";

export function AppProvider({ children }) {
  const [showModal, setShowModal] = useState(null);
  const [cameraState, setCameraState] = useState(0);
    
  return (
    <AppContext.Provider value={{ showModal, setShowModal, cameraState, setCameraState }}>
      {children}
    </AppContext.Provider>
  );
}
